<!--团体报告-->
<template>
  <a-card>
    <a-form-model layout="inline" :model="searchForm" class="search-form">
      <a-form-model-item label="报告名称">
        <a-input :maxLength="30" allowClear class="serach-item" v-model.trim="searchForm.name"
                 placeholder="请输入报告名称" />
      </a-form-model-item>
      <a-form-model-item label="机构名称">
        <a-select showSearch optionFilterProp="title" class="serach-item" allowClear
                  v-model="searchForm.organizationIds" placeholder="请选择机构名称">
          <a-select-option :value="item.id" :key="item.id" :title="item.name" v-for="item in organizationList">
            {{ item.name }}
          </a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item label="状态">
        <a-select class="serach-item" allowClear v-model="searchForm.status" placeholder="请选择报告状态">
          <a-select-option :value="item.value" v-for="item in statusList">{{ item.name }}</a-select-option>
        </a-select>
      </a-form-model-item>
      <a-form-model-item style="margin-right: 35px;">
        <a-button @click="getPageList(1)" type="primary" html-type="button">
          查询
        </a-button>
        <a-button @click="searchReset" style="margin-left: 10px;">
          重置
        </a-button>
      </a-form-model-item>
      <a-form-model-item v-permission="`add`">
        <a-button @click="addReport" icon="plus" type="primary">添加报告</a-button>
      </a-form-model-item>
    </a-form-model>
    <a-table :columns="columns" style="min-width: 800px;"
             :rowKey="(text, index) => text.id + index"
             :pagination="tableRelevant.tablePagination"
             :loading="tableRelevant.tableLoading"
             :locale="tableRelevant.locale"
             :dataSource="tableRelevant.tableDataSource">
      <div slot="expectedProgress" slot-scope="text, record">
        {{ text.expectedProgress }}%
      </div>
      <div slot="reportType" slot-scope="text, record">
        {{ reportTypes[text] }}
      </div>
      <div slot="status" slot-scope="text, record">
        <span v-if="text.status === 0" style="color:#409EFF;">配置中</span>
        <span v-if="text.status === 1" style="color:#E6A23C;">生成中</span>
        <span v-if="text.status === 2" style="color:#67C23A;">已生成</span>
        <a-tooltip>
          <template slot="title">
            {{ text.errorMessage }}
          </template>
          <span v-if="text.status === 3" style="color:#F56C6C;">生成失败</span>
        </a-tooltip>

      </div>
      <div slot="action" class="operate" slot-scope="text, record">
        <a-button @click="edit(text)" v-permission="`edit`" :disabled="[1].includes(text.status)"
                  icon="edit" type="link">
          编辑
        </a-button>
        <a-popconfirm title="确认删除此报告？" @confirm="del(text)">
          <a-button v-permission="`delete`" danger icon="delete" type="link">
            删除
          </a-button>
        </a-popconfirm>
        <a-dropdown>
          <a class="ant-dropdown-link" @click="e => e.preventDefault()">
            更多
            <a-icon type="down" />
          </a>
          <a-menu slot="overlay">
            <a-menu-item v-permission="`again`">
              <a-button @click="generateGroupReport(text)" :disabled="[0].includes(text.status)" type="link">
                重新生成
              </a-button>
            </a-menu-item>
            <a-menu-item v-permission="`download`">
              <a-button :disabled="!(text.status === 2 && text.wordReportUrl)" type="link">
                <a download :href="text.wordReportUrl | filterUrl">下载报告</a>
              </a-button>
            </a-menu-item>
            <a-menu-item v-permission="`detail`">
              <a-button @click="look(text)" :disabled="text.status === 0" type="link">
                查看详情
              </a-button>
            </a-menu-item>
          </a-menu>
        </a-dropdown>
      </div>
    </a-table>

    <!--添加/编辑报告-->
    <a-modal v-model="modelForm.visible"
             :centered="true"
             :footer="null"
             width="100%"
             wrapClassName="create-report"
             @cancel="modelFormCancel"
             :destroyOnClose="true"
             :title="modelForm.title">
      <CreateReport :report-id="modelForm.id" />
    </a-modal>

    <!--查看报告详情-->
    <a-modal v-model="lookReport.visible"
             :centered="true"
             :footer="null"
             width="100%"
             wrapClassName="create-report"
             :destroyOnClose="true"
             title="报告详情">
      <report-details :key="Date.now()" :report-info="lookReport.info" />
    </a-modal>
  </a-card>
</template>

<script>
import { tableRelevant } from "@/pages/projectImpl/js/utils";
import CreateReport from "./createReport/CreateReport.vue";
import ReportDetails from "./reportDetail/ReportDetails.vue";

const columns = [
  {
    title: "报告名称",
    dataIndex: "name",
    ellipsis: true,
    width: 200,
  },
  {
    title: "报告类型",
    dataIndex: "reportType",
    width: 150,
    scopedSlots: { customRender: "reportType" },
  },
  {
    title: "机构名称",
    dataIndex: "organizationName",
    width: 200,
  },
  {
    title: "期望进度",
    width: 150,
    scopedSlots: { customRender: "expectedProgress" },
  },
  {
    title: "状态",
    width: 150,
    scopedSlots: { customRender: "status" },
  },
  {
    title: "报告日期",
    width: 140,
    align: "center",
    dataIndex: "reportDate",
    customRender: text => text.split(" ")[0],
  },
  {
    width: 200,
    title: "操作",
    scopedSlots: { customRender: "action" },
  },
];

export default {
  name: "GroupReport",
  components: { CreateReport, ReportDetails },
  data() {
    return {
      reportTypes: ["", "单校团体训练报告"],
      columns,
      searchForm: {
        name: undefined,
        organizationIds: undefined,
        status: undefined,
      },
      organizationList: [],
      statusList: [
        { name: "配置中", value: 0 },
        { name: "生成中", value: 1 },
        { name: "已生成", value: 2 },
        { name: "生成失败", value: 3 },
      ],
      //表格相关
      tableRelevant: tableRelevant.call(this),
      //添加、编辑报告相关
      modelForm: {
        visible: false,
        confirmLoading: false,
        title: "添加报告",
        id: "",
      },
      //查看报告
      lookReport: {
        visible: false,
        info: {},
      },
      // 替换报告
      replace: {
        visible: false,
        loading: false,
        fileList: [],
        file: "",
        id: "",
      },
    };
  },
  mounted() {
    this.getPageList();
    this.getOrganizationList();
    this.$bus.$on("closeCreateReport", () => {
      this.modelFormCancel();
    });
    this.$bus.$on("copyTrainingReport", id => {
      this.$store.commit("organization/setReportInfo", { id });
      this.modelForm.visible = true;
      this.modelForm.title = "编辑报告";
      this.lookReport.visible = false;
    });
  },
  methods: {
    //获取报告列表
    getPageList(pageIndex) {
      const params = {
        pageIndex: pageIndex || this.tableRelevant.tablePagination.current,
        pageSize: this.tableRelevant.tablePagination.pageSize,
        ...this.searchForm,
      };
      this.tableRelevant.tableLoading = true;
      this.$http.ReportService.GroupTrainingReportPagelist(params).then(res => {
        this.tableRelevant.tableDataSource = res.data.items;
        this.tableRelevant.tablePagination.total = res.data.totalCount;
        this.tableRelevant.tablePagination.current = res.data.pageIndex;
      }).finally(() => {
        this.tableRelevant.tableLoading = false;
      });
    },
    //获取所有机构
    getOrganizationList() {
      this.$http.loadAllByType({ isOnlySuperior: false }).then((res) => {
        this.organizationList = res.data.data;
      });
    },
    //重置
    searchReset() {
      for (let searchFormKey in this.searchForm) {
        this.searchForm[searchFormKey] = undefined;
      }
      this.getPageList(1);
    },
    //添加报告
    addReport() {
      this.modelForm.title = "添加报告";
      this.modelForm.id = "";
      this.$store.commit("organization/setReportInfo", {});
      this.modelForm.visible = true;
    },
    //编辑报告
    edit(val) {
      this.$store.commit("organization/setReportInfo", val);
      this.modelForm.title = "编辑报告";
      this.modelForm.visible = true;
    },
    //删除报告
    del(val) {
      this.tableRelevant.tableLoading = true;
      this.$http.ReportService.GroupTrainingReportDelete(val.id).then(res => {
        this.$message.success(res.message);
        this.getPageList(1);
      }).finally(() => {
        this.tableRelevant.tableLoading = false;
      });
    },
    //修改报告状态
    reload(val, s = 2) {
      const fn = () => {
        this.tableRelevant.tableLoading = true;
        this.$http.GroupReport.updateStatus(new URLSearchParams({
          id: val.id,
          status: s,
        })).then(res => {
          this.$message.success(res.message);
          this.getPageList(1);
        }).finally(() => {
          this.tableRelevant.tableLoading = false;
        });
      };
      if (s === 6) {
        this.$confirm({
          title: "确认发布此报告？",
          centered: true,
          onOk: () => {
            fn();
          },
        });
        return;
      }
      fn();
    },
    // 重新生成报告
    generateGroupReport(val) {
      this.$confirm({
        title: "确认重新生成此报告？",
        centered: true,
        onOk: () => {
          this.tableRelevant.tableLoading = true;
          this.$http.ReportService.GroupTrainingReportGenerate(val.id).then(res => {
            this.$message.success(res.message);
            this.getPageList();
          }).finally(() => {
            this.tableRelevant.tableLoading = false;
          });
        },
      });
    },
    //查看报告详情
    look(val) {
      this.lookReport.info = val;
      this.$store.commit("organization/setReportInfo", val);
      this.lookReport.visible = true;
    },

    //添加编辑报告弹出框取消
    modelFormCancel() {
      const bool = this.modelForm.title === "添加报告";
      this.modelForm.visible = false;
      this.modelForm.title = "添加报告";
      this.$store.commit("organization/setReportInfo", {});
      if (bool) {
        this.getPageList(1);
      } else {
        this.getPageList();
      }
    },
    // 替换报告
    replaceOpen(record) {
      console.log(record);
      this.replace.visible = true;
      this.replace.id = record.id;
    },
    handleRemove(file) {
      const index = this.replace.fileList.indexOf(file);
      const newFileList = this.replace.fileList.slice();
      newFileList.splice(index, 1);
      this.replace.fileList = newFileList;
    },
    beforeUpload(file) {
      const bool = this.replace.fileList.filter(v => v.name === file.name).length;
      if (bool) {
        this.replace.$message.warning("已有相同的文件，请重新选择文件");
        return false;
      }
      // this.replace.fileList = [...this.replace.fileList, file];
      this.replace.fileList = [file];
      return false;
    },
    unploadChange(value) {
      if (value.fileList.length) {
        this.replace.file = value.file;
      } else {
        this.replace.file = "";
      }
    },
    replaceOk() {
      if (this.replace.file == "") {
        this.$message.destroy();
        this.$message.warning("请选择文件");
        return;
      }
      this.replace.loading = true;
      let url = "/file/file/upload?filePath=GroupReports/" + this.replace.id + "&fileName=" + this.replace.file.name;
      let formData = new FormData();
      formData.append("imgFile", this.replace.file);
      this.$http.File.upload(url, formData)
        .then(data => {
          this.submit(data.data);
        })
        .finally(() => {
          this.replace.loading = false;
        });

    },
    submit(url) {
      let formData = new FormData();
      formData.append("wordReportUrl", url);
      formData.append("groupReportId", this.replace.id);
      this.$http.GroupReport.replaceReport(formData)
        .then(res => {
          this.$message.destroy();
          this.$message.success("操作成功");
          this.getPageList();
          this.replace.visible = false;
          this.replace.fileList = [];
          this.replace.file = "";
        }).finally(() => {
        this.replace.loading = false;
      });
    },
    closeModle() {
      this.replace.visible = false;
      this.replace.fileList = [];
      this.replace.file = "";
    },
  },
};
</script>

<style scoped lang="less">
/deep/ .create-report .ant-modal {
  width: 100%;
  height: 100%;
  padding-bottom: 0;
}

/deep/ .create-report .ant-modal-content {
  height: 100%;
  padding-bottom: 0;
}

.table-orgName {
  overflow: hidden;
  /* 三行显示省略号 */
  display: -webkit-box;
  -webkit-box-orient: vertical;
  -webkit-line-clamp: 2;
}
</style>
